import React from 'react'

import Auth from '../../Auth'

import FormPage from '../FormPage'
import InternationPhoneInput from "../../components/form/InternationPhoneInput";

export default class AuthProfile extends FormPage {
    static path = '/account/profile'

    /**
     * The css class for the page container
     *
     * @var {String}
     */
    static BGClass = 'bordered-panel'

    /**
     * The max width in pixels for the form container
     *
     * @var {Integer}
     */
    static MaxWidth = 800

    /**
     * The title shown on the form
     */
    static FormTitle = 'auth.edit_profile.title'

    /**
     * The api endpoint path that the form should send a post request to
     */
    static FormPost = '/api/sessions/update'

    /**
     * The submit button title for the form
     */
    static FormSubmit = 'auth.edit_profile.submit_button'

    /**
     * The fields mapping for the form
     */
    formFields() {
        return this.transFormFields([
            {
                style: styles.fieldSection,
                fields: {
                    image_path: {
                        label: 'auth.edit_profile.image_label',
                        type: 'pixie',
                        maxWidth: 400,
                        ratio: '1:1',
                        circular: false,
                        required: false,
                        style: {...styles.field, alignItems: 'center'},
                        className: ''
                    },
                },
            },
            {
                style: styles.fieldSection,
                fields: {
                    first_name: {
                        label: 'auth.edit_profile.first_name_label',
                        required: true,
                        columns: 6,
                        style: styles.field,
                    },
                    last_name: {
                        label: 'auth.edit_profile.last_name_label',
                        required: true,
                        columns: 6,
                        style: styles.field,
                    },
                },
            },
            {
                style: styles.fieldSection,
                fields: {
                    email: {
                        label: 'auth.edit_profile.email_label',
                        type: 'email',
                        required: true,
                        columns: 6,
                        style: styles.field,
                    },
                    phone: {
                        label: 'auth.edit_profile.phone_label',
                        type: 'antd-input',
                        children: (
                            <InternationPhoneInput/>
                        ),
                        required: false,
                        columns: 6,
                        style: styles.field,
                    },
                },
            },
            {
                style: styles.fieldSection,
                fields: {
                    job_title: {
                        label: 'auth.edit_profile.job_label',
                        required: false,
                        columns: 6,
                        style: styles.field,
                    },
                    location: {
                        label: 'auth.edit_profile.location_label',
                        type: 'location',
                        required: false,
                        columns: 6,
                        style: styles.field,
                    },
                },
            },
            {
                style: styles.fieldSection,
                fields: {
                    preferred_meeting_link: {
                        label: 'Preferred Conference Details for Talent Interviews',
                        required: false,
                        type: 'lexical-editor',
                        rows: 6,
                        columns: 12,
                        maxLength: 2000,
                        style: styles.field,
                        tools: ['bold', 'italic', 'underline', 'link', 'ol', 'ul'],
                        placeholder: 'Add your preferred conference details for for scheduling talent interviews (i.e., Zoom, Teams)'
                    },
                },
            }
        ])
    }

    /**
     * [Constructor]
     *
     * @param {Object} props
     * @returns {FormPage}
     */
    constructor(props) {
        super(props)
        let model = {...Auth.user()};
        if (model.phone) {
            let phoneNumber = model.phone.replace(/\D/g, '');
            if (phoneNumber?.length === 10 && !model.phone.includes('+')) {
                model.phone = "+1 " + model.phone;
            }
        }
        this.state = {
            ...this.state,
            model,
            auth: Auth.user()
        }
    }

    /**
     * Overridable method for mapping form input data to form submit models
     *
     * @param {Object} model
     * @returns {Object}
     */
    mapping(model) {
        model = super.mapping(model)

        model.image = model.image_path
        return model
    }

    /**
     * Handles successful responses returned by TB Request
     *
     * @param {Object} responseData
     * @returns void
     */
    onSuccess(responseData) {
        TB.alert(
            'success',
            'auth.edit_profile.success.title',
            'auth.edit_profile.success.message'
        )

        Auth.update({...responseData.data.auth})
    }

    renderFormChildren() {
        // if (!this.constructor.IncludeExtraFields) return null;
        const myGroups = this.state.auth.client_project_groups || []

        if (!myGroups?.length) {
            return null
        }
        return (
            <div className="my-groups-container">
                <p className="my-groups-title">My Groups</p>

                {(!myGroups || !myGroups.length) ? (
                    <p className="my-groups-name">You have not been invited to any groups yet</p>
                ) : (
                    myGroups.map(item => {
                        return <p key={item.id} className="my-groups-name">{item.name}</p>
                    })
                )}

            </div>
        )
    }
}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
}